export { default as Nav } from "./nav-bar";
export { default as Footer } from "./footer";
export { default as AlgoliaAutoCompleteSearch } from "./algolia-autocomplete-search";
export { default as CloudinaryUpload } from "./cloudinary-upload";
export * from "./head";
export * from "./footer";
export * from "./algolia-autocomplete-search";
